<template>
  <div
    v-if="hasSubmitButton"
    class="mt-32 hidden w-full flex-row-reverse md:flex"
  >
    <RevButton
      data-qa="submit-section-desktop"
      :disabled="isLoadingOffer || disabled"
      :form="formId"
      type="submit"
      variant="primary"
    >
      {{ buttonLabel }}
    </RevButton>
  </div>

  <RevStickyBar v-if="hasSubmitButton" ref="stickyBarRef" class="md:hidden">
    <RevButton
      data-qa="submit-section-mobile"
      :disabled="isLoadingOffer || disabled"
      :form="formId"
      full-width="always"
      type="submit"
      variant="primary"
    >
      {{ buttonLabel }}
    </RevButton>
  </RevStickyBar>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'

import { RevButton } from '@ds/components/Button'
import { RevStickyBar } from '@ds/components/StickyBar'

import { useStickyBarBottomHeightLogic } from '~/composables/useStickyBarBottomHeightLogic'

defineProps<{
  hasSubmitButton: boolean
  disabled: boolean
  isLoadingOffer: boolean
  buttonLabel: string
  formId: string
}>()

const stickyBarRef =
  useTemplateRef<InstanceType<typeof RevStickyBar>>('stickyBarRef')
useStickyBarBottomHeightLogic(stickyBarRef)
</script>
